import {
  FontSizeEnum,
  FontWeightEnum,
  IconSizeEnum,
  Typography,
  ValidatorClockIcon,
} from '@acceso/design-system';
import clsx from 'clsx';
import { useEffect, useState } from 'react';

import { formatInAppTz } from '@/utils/spain-time';

type ClockProps = {
  className?: string;
  iconSize?: IconSizeEnum;
  fontSize?: FontSizeEnum;
};

export function Clock({
  className,
  iconSize = IconSizeEnum.MD,
  fontSize = FontSizeEnum.Xl,
}: ClockProps) {
  const [date, setDate] = useState(new Date());

  useEffect(() => {
    const dateUpdaterInterval = setInterval(() => {
      setDate(new Date());
    }, 1_000);

    return () => {
      clearInterval(dateUpdaterInterval);
    };
  }, []);

  return (
    <div className={clsx('flex items-center gap-size-4', className)}>
      <ValidatorClockIcon size={iconSize} />

      <Typography weight={FontWeightEnum.Bold} fontSize={fontSize}>
        {formatInAppTz(date, 'h:mma')}
      </Typography>
    </div>
  );
}
